import { render, staticRenderFns } from "./CreateStation.vue?vue&type=template&id=0fd0b874&scoped=true&"
import script from "./CreateStation.vue?vue&type=script&lang=js&"
export * from "./CreateStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0b874",
  null
  
)

export default component.exports